import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Register } from '../../_models/register';
import { Router, ActivatedRoute } from '@angular/router';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-rzr-pmt-resp',
  templateUrl: './rzr-pmt-resp.component.html',
  styleUrls: ['./rzr-pmt-resp.component.scss'],
})
export class RzrPmtRespComponent implements OnInit {
  value: any;
  constructor(private _location: Location, private alertService: AlertService, private http: HttpClient, private router: Router, public register: Register, public caller: Caller, private route: ActivatedRoute) {
    this.value = this.route.snapshot.params['value'];
    console.log("Value:" + this.value);
  }

  ngOnInit() { }

}
